import React from "react";
import { 
  PieChart, 
  Pie, 
  Cell, 
  ResponsiveContainer, 
  Legend, 
  Tooltip 
} from "recharts";

// This component will replace the Sales by Locations section in your dashboard
const SalesByLocations = () => {
  // Sample data for locations
  const locationData = [
    { name: "Canada", value: 75, color: "rgb(64, 81, 137)" },
    { name: "Greenland", value: 47, color: "rgb(10, 179, 156)" },
    { name: "Russia", value: 82, color: "rgb(247, 184, 75)" },
    { name: "Palestine", value: 86, color: "rgb(240, 101, 72)" }
  ];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text 
        x={x} 
        y={y} 
        fill="white" 
        textAnchor={x > cx ? 'start' : 'end'} 
        dominantBaseline="central"
        fontSize="12"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium">Customers by Locations</h3>
        <button className="bg-gray-100 text-gray-700 px-3 py-1 rounded-md text-sm">Export Report</button>
      </div>

      {/* Responsive Pie Chart */}
      <div className="h-64 md:h-72">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={locationData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={90}
              fill="#8884d8"
              dataKey="value"
            >
              {locationData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value}%`} />
            <Legend 
              layout="horizontal" 
              verticalAlign="bottom" 
              align="center"
              wrapperStyle={{ paddingTop: "20px" }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Location Percentages */}
      <div className="space-y-4 mt-4">
        {locationData.map((location, index) => (
          <div key={index}>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium">{location.name}</span>
              <span className="text-sm font-medium">{location.value}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="h-2 rounded-full" 
                style={{ width: `${location.value}%`, backgroundColor: location.color }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesByLocations;